import CartCalculations from '../models/CartCalculation';

const CART_CALCULATION: CartCalculations = {
    ach: {
      convenienceFee: 0,
      achTotal: 0
    },
    creditCart: {
      convenienceFee: 0,
      ccTotal: 0,
      stripeTax: 0
    },
    itemsCount: 0,
    remainDue: 0,
  };

export {
  CART_CALCULATION
}